export const Attivita_section3 = () => {
    return (
        <div>
            <h3><img src={"images/centroestivo/loghi/logo_masa.png"} width="23%"/></h3><h3 className="shadowtext-1bl">Kayak</h3>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_bianconiglio.png"} width="23%" style={{marginTop:"-10px"}}/> </h3><h3 className="shadowtext-1bl">Caccia alla storia perduta</h3>
            <h6 className="new-badge align-center">NEW</h6>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_padel.png"} width="20%" /> </h3><h3 className="shadowtext-1bl">Introduzione al padel</h3>
            <h6 className="new-badge align-center">NEW</h6>
        </div>
    )
}